import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: true,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      en: {
        translation: {
            home: {
                slogan: 'Empowering Businesses', 
                description: 'Embrace the change with IT Solutions to revolutionize your business',
                mission: 'Our mission is to drive digital transformation for businesses by delivering tailored automation solutions that enhance efficiency, optimize processes, and improve customer experiences.'
            },
            services: {
                title: 'Our Services', 
                description: 'At DoSmart, we offer a range of services designed to help your business thrive in the digital age',
                service1: {
                    title: 'Strategic IT Consulting', 
                    description: 'With extensive experience in business process management and IT consulting, DoSmart helps you challenge your current strategies, structure your initiatives, and adopt the governance models that best fit your unique challenges',
                },
                service2: {
                    title: 'Dedicated IT Support', 
                    description: 'At DoSmart, we understand that implementing new technologies is just the beginning. Our dedicated support team ensures that your solutions continue to run smoothly, providing assistance whenever you need it.',
                },
                service3: {
                    title: 'End-to-End Software Development', 
                    description: 'Our software development services are focused on delivering solutions that meet your specific needs. From initial concept to final implementation, we ensure that every project is completed with the highest level of quality and efficiency',
                },
                service4: {
                    title: 'Comprehensive Training Programs', 
                    description: 'We believe that informed clients are better equipped to succeed. Our training programs are designed to transfer knowledge to your team, ensuring they can manage and expand your initiatives independently',
                },
            },
            features: {
                title: 'Team Skills and Experience', 
                description: 'We bring the expertise and capabilities to streamline operations, enhance decision-making, and drive innovation across your organization, leveraging our experience and skills to deliver impactful solutions.',
                feature1: {
                    title: 'Business Process Management (BPM)', 
                    description: 'We specialize in automating business processes from start to finish, ensuring that human, robotic, and system activities are seamlessly integrated. Our BPM solutions provide a clear roadmap for each process, enabling all stakeholders to understand what needs to be done and when.',
                },
                feature2: {
                    title: 'Business Rules Management (Decisions)', 
                    description: 'We streamline the management of your business rules by centralizing, defining, classifying and automating them. We help creating rules that support workflows, ensuring that critical decisions, such as product scoring or offer optimization, are consistent, efficient and reliable.',
                },
                feature3: {
                    title: 'Artificial Intelligence & Machine Learning', 
                    description: 'By bringing intelligence into your business, we help you predict trends, automate decisions, and improve overall process performance.',
                },
                feature4: {
                    title: 'Robotics Process Automation (RPA)', 
                    description: 'We build RPA solutions to free your employees from time-consuming, repetitive tasks, allowing them to focus on more strategic activities and help you achieve significant efficiency gains.',
                },
                feature5: {
                    title: 'Intelligent Document Processing', 
                    description: 'We build solutions to capture and store documents intelligently, adding insights and analytical tools that enhance data manipulation and understanding. Our approach ensures efficient storage and effective management of both digitized and automatically generated documents.',
                },
                feature6: {
                    title: 'Data Analytics & BI', 
                    description: 'The automation of processes, documents and data capture from our clients generates valuable information ready for exploration, offering significant competitive advantages. We guide our clients on this discovery, helping them unlock the full potential of their data.',
                },
                feature7: {
                    title: 'System Integrations', 
                    description: 'We help businesses integrate their internal and external systems, creating a cohesive IT environment that supports all aspects of operations. Whether you need to connect legacy systems or integrate with external applications, we provide solutions that ensure seamless communication and data flow.',
                }
            },
            team: {
                title:'Meet Our Team',
                nunoperdigao: {
                    name: 'Nuno Perdigão', 
                    role: 'CEO | Founder', 
                    description: 'Leads business development with over 21 years experience',
                },
                ricardojorge: {
                    name: 'Ricardo Jorge', 
                    role: 'Director | Founder', 
                    description: '22 years in IT, specialized in project management and solutions design for banking and insurance',
                },
                pedrosilva: {
                    name: 'Pedro Nuno Silva', 
                    role: 'Director | Founder', 
                    description: 'Expert in project management and solution architecture and automation with 14+ years experience',
                },
                brunoanastacio:{
                    name:"Bruno Anastácio",
                    role:"Senior Software Developer",
                    description:"Full Stack Developer skilled in process automation and integration"
                },
                joaoverdilheiro: {
                    name:"João Verdilheiro",
                    role:"Senior Software Developer",
                    description:"Full Stack Developer skilled in process automation and integration"
                },
                flaviogil: {
                    name:"Flávio Gil",
                    role:"Senior Software Developer",
                    description:"Senior Developer skilled in IBM automation technologies"
                },
                    bernardorodrigues: {
                    name:"Rui Bernardo Rodrigues",
                    role:"Software Developer"                    
                },
                    antonioeusebio: {
                    name:"António Eusébio",
                    role:"Software Developer"                    
                },
                    ritaandrino: {
                    name:"Rita Andrino",
                    role:"Software Developer"                    
                }
            },
            contacts: {
                title: 'Contact Us',
                email: {
                    title: 'Email',
                    address: 'geral@dosmart.pt',
                    description: 'Reach out to us for any inquiries or collaborations.'
                },
                phone: {
                    title: 'Phone',
                    number: '+351 241 098 183',
                    description: 'We are here to support your digital transformation journey.'
                },
                address: {
                    title: 'Office',
                    description: 'Connect with us today!',
                    line1: 'Rua José Dias Simão, s/n,',
                    line2: 'TagusValley, Ed. Inov.Point,',
                    line3: '2200-062 Abrantes'
                },
            },
            support: {
                title: 'Support',
                titleSecondary: 'Estágios Iniciar e Estágios +Talento - IEFP',
                description: 'Promote entry and reintegration into the job market',
                sheet: 'Project Sheet',
                support2title: 'Medida +Emprego - IEFP', 
            },
            footer: {
                copyright: '©2026 Do Smart IT Consulting, LDA, a Portuguese limited liability company. All rights reserved.',
                links: {
                    home: 'Home',
                    services: 'Services',
                    skills: 'Skills & Experience',
                    team: 'Team',
                    contacts: 'Contacts',
                }
            }          
        }
      },
      pt: {
        translation: {
            home: {
                slogan: 'Potenciar Negócios', 
                description: 'Abrace a mudança com soluções de TI que revolucionarão o seu negócio',
                mission: 'A nossa missão é impulsionar a transformação digital para empresas, fornecendo soluções de automação personalizadas que aumentam a eficiência, otimizam processos e melhoram a experiência do cliente.'
            },     
            services:{
                title:"Os Nossos Serviços",
                description:"Na DoSmart, oferecemos uma gama de serviços projetados para ajudar o seu negócio a prosperar na era digital",
                service1: {
                    title:"Consultoria Estratégica em TI",
                    description:"Com ampla experiência em gestão de processos empresariais e consultoria em TI, a DoSmart ajuda a desafiar as suas estratégias atuais, a estruturar as suas iniciativas e a adotar os modelos de governança que melhor se adequam aos seus próprios desafios."
                },
                service2: {
                    title:"Suporte Dedicado de TI",
                    description:"Na DoSmart, entendemos que a implementação de novas tecnologias é apenas o começo. A nossa equipa de suporte dedicada garante que as suas soluções continuem a funcionar sem problemas, oferecendo assistência sempre que necessário."
                },
                service3: {
                    title:"Desenvolvimento de Software",
                    description:"Os nossos serviços de desenvolvimento de software focam-se em entregar soluções completas que atendam às suas necessidades específicas. Desde o conceito inicial até à implementação final, garantimos que cada projeto seja concluído com o maior nível de qualidade e eficiência."
                },
                service4: {
                    title:"Programas de Formação Abrangentes",
                    description:"Acreditamos que clientes informados estão melhor preparados para o sucesso. Os nossos programas de formação são projetados de forma a transferir conhecimento para as suas equipa, garantindo que possam gerir e expandir as suas iniciativas de forma independente."
                }
                },
                features:{
                    title:"Competências e Experiência",
                    description:"Trazemos a expertise e as capacidades necessárias para otimizar operações, melhorar a tomada de decisões e impulsionar a inovação em toda a organização, através da entrega de soluções impactantes.",
                    feature1:{
                    title:"Gestão de Processos de Negócio (BPM)",
                    description:"Especializamo-nos na automação de processos de negócios, garantindo que todas as atividades humanas, robóticas e de sistema sejam integradas perfeitamente. As nossas soluções BPM traduzem um desenho claro de cada processo, permitindo que todas as partes interessadas compreendam as suas tarefas."
                    },
                    feature2:{
                    title:"Gestão de Regras de Negócio (Decisões)",
                    description:"Simplificamos a gestão das suas regras de negócio centralizando, definindo, classificando e automatizando as mesmas. Ajudamos a criar regras que suportam fluxos de trabalho, garantindo que decisões críticas, como a classificação de produtos ou a otimização de ofertas, sejam consistentes, eficientes e confiáveis."
                    },
                    feature3:{
                    title:"Inteligência Artificial & Aprendizagem Automática",
                    description:"Trazemos inteligência para o seu negócio, ajudando a prever tendências, a automatizar decisões e a melhorar o desempenho geral dos processos."
                    },
                    feature4:{
                    title:"Automação de Processos Robóticos (RPA)",
                    description:"Construímos soluções de RPA para libertar da necessidade de tarefas repetitivas e demoradas, permitindo um foco em atividades estratégicas e ajudando a alcançar ganhos significativos de eficiência."
                    },
                    feature5:{
                    title:"Processamento Inteligente de Documentos",
                    description:"Desenvolvemos soluções para capturar e armazenar documentos de forma inteligente, acrescentando informação e ferramentas analíticas que melhoram a manipulação e a compreensão dos dados. A nossa abordagem garante um armazenamento eficiente e uma gestão eficaz de documentos digitalizados ou gerados automaticamente."
                    },
                    feature6:{
                    title:"Análise de Dados & BI",
                    description:"A automação de processos, documentos e captura de dados dos nossos clientes gera informações valiosas prontas para análse e exploração, oferecendo vantagens competitivas significativas. Orientamos os nossos clientes nessa descoberta, ajudando-os a desbloquear todo o potencial dos seus dados."
                    },
                    feature7:{
                    title:"Integrações de Sistemas",
                    description:"Ajudamos as empresas a integrarem os seus sistemas internos e externos, criando um ambiente de TI coeso que suporta todos os aspetos das operações. Quer precise de integrar com sistemas legados ou com aplicações externas, oferecemos soluções que garantem comunicação e fluxo de dados sem interrupções."
                    }
                },
                team:{
                    title:"Conheça a Nossa Equipa",
                    nunoperdigao:{
                    name:"Nuno Perdigão",
                    role:"CEO | Fundador",
                    description:"Lidera o desenvolvimento de negócios com mais de 21 anos de experiência"
                    },
                    ricardojorge:{
                    name:"Ricardo Jorge",
                    role:"Diretor | Fundador",
                    description:"22 anos em TI, especializado em gestão de projetos e design de soluções para a banca e seguros"
                    },
                    pedrosilva:{
                    name:"Pedro Nuno Silva",
                    role:"Diretor | Fundador",
                    description:"Especialista em gestão de projetos, automação e arquitetura de soluções com mais de 14 anos de experiência"
                    },
                    brunoanastacio:{
                    name:"Bruno Anastácio",
                    role:"Programador de Software Sénior",
                    description:"Programador Full Stack especializado em automação de processos e integração"
                    },
                    joaoverdilheiro: {
                    name:"João Verdilheiro",
                    role:"Programador de Software Sénior",
                    description:"Programador Full Stack especializado em automação de processos e integração"
                    },
                    flaviogil: {
                    name:"Flávio Gil",
                    role:"Programador de Software Sénior",
                    description:"Programador Sénior especializado em tecnologias de automação IBM"
                    },
                    bernardorodrigues: {
                    name:"Rui Bernardo Rodrigues",
                    role:"Programador de Software"                    
                    },
                    antonioeusebio: {
                    name:"António Eusébio",
                    role:"Programador de Software"                    
                    },
                    ritaandrino: {
                    name:"Rita Andrino",
                    role:"Programador de Software"                    
                    }
                },
                contacts:{
                    title:"Contacte-nos",
                    email:{
                    title:"Email",
                    address:"geral@dosmart.pt",
                    description:"Entre em contacto connosco para qualquer dúvida ou possível colaboração."
                    },
                    phone:{
                    title:"Telefone",
                    number:"+351 241 098 183",
                    description:"Estamos aqui para o apoiar na sua jornada de transformação digital."
                    },
                    address:{
                    title:"Escritório",
                    description:"Visite-nos hoje!",
                    line1:"Rua José Dias Simão, s/n,",
                    line2:"TagusValley, Ed. Inov.Point,",
                    line3:"2200-062 Abrantes"
                    }
                },
                support: {
                    title: 'Apoios',
                    titleSecondary: 'Estágios Iniciar e Estágios +Talento - IEFP',
                    description: 'Promover a inserção e a reinserção no mercado de trabalho',
                    sheet: 'Cartaz do Projecto',
                    support2title: 'Medida +Emprego - IEFP',                    
                },
                footer: {
                    copyright:"©2026 Do Smart IT Consulting, LDA, uma empresa de responsabilidade limitada portuguesa. Todos os direitos reservados.",
                    links:{
                    home:"Início",
                    services:"Serviços",
                    skills:"Competências & Experiência",
                    team:"Equipa",
                    contacts:"Contactos"
                }
            }       
        }
      },
      es: {
        translation: {
            home: {
                slogan: 'Empoderando Negocios',
                description: 'Abraza el cambio con Soluciones IT para revolucionar tu negocio',
                mission: 'Nuestra misión es impulsar la transformación digital de las empresas mediante la entrega de soluciones de automatización personalizadas que mejoran la eficiencia, optimizan los procesos y mejoran las experiencias de los clientes.'
            },
            services: {
                title: 'Nuestros Servicios',
                description: 'En DoSmart, ofrecemos una gama de servicios diseñados para ayudar a tu negocio a prosperar en la era digital',
                service1: {
                    title: 'Consultoría IT Estratégica',
                    description: 'Con amplia experiencia en gestión de procesos de negocio y consultoría IT, DoSmart te ayuda a desafiar tus estrategias actuales, estructurar tus iniciativas y adoptar los modelos de gobernanza que mejor se adapten a tus desafíos únicos',
                },
                service2: {
                    title: 'Soporte IT Dedicado',
                    description: 'En DoSmart, entendemos que implementar nuevas tecnologías es solo el comienzo. Nuestro equipo de soporte dedicado asegura que tus soluciones sigan funcionando sin problemas, brindando asistencia cuando la necesites.',
                },
                service3: {
                    title: 'Desarrollo de Software',
                    description: 'Nuestros servicios de desarrollo de software se centran en ofrecer soluciones que satisfagan tus necesidades específicas. Desde el concepto inicial hasta la implementación final, nos aseguramos de que cada proyecto se complete con el más alto nivel de calidad y eficiencia',
                },
                service4: {
                    title: 'Programas de Formación',
                    description: 'Creemos que los clientes informados están mejor equipados para tener éxito. Nuestros programas de formación están diseñados para transferir conocimientos a tu equipo, asegurando que puedan gestionar y expandir tus iniciativas de forma independiente',
                },
            },
            features: {
                title: 'Habilidades y Experiencia del Equipo',
                description: 'Aportamos la experiencia y las capacidades para optimizar las operaciones, mejorar la toma de decisiones e impulsar la innovación en toda tu organización, aprovechando nuestra experiencia y habilidad para ofrecer soluciones impactantes.',
                feature1: {
                    title: 'Gestión de Procesos de Negocio (BPM)',
                    description: 'Nos especializamos en automatizar procesos de negocio, asegurando que todas las actividades humanas, robóticas y de sistemas estén perfectamente integradas. Nuestras soluciones BPM traduzem um desenho claro de cada proceso, permitiendo que todas las partes interesadas entiendan qué se debe hacer y cuándo.',
                },
                feature2: {
                    title: 'Gestión de Reglas de Negocio (Decisiones)',
                    description: 'Optimizamos la gestión de tus reglas de negocio centralizándolas, definiéndolas, clasificándolas y automatizándolas. Ayudamos a crear reglas que respalden los flujos de trabajo, asegurando que las decisiones críticas, como la clasificación de productos o la optimización de ofertas, sean consistentes, eficientes y confiables.',
                },
                feature3: {
                    title: 'Inteligencia Artificial y Aprendizaje Automático',
                    description: 'Trazemos inteligencia para su negocio, ayudando a prevenir tendencias, automatizar decisiones y mejorar el desempeño general de dos procesos.',
                },
                feature4: {
                    title: 'Automatización Robótica de Procesos (RPA)',
                    description: 'Construímos soluciones de RPA para liberar la necesidad de tarefas repetitivas y demoradas, permitiendo un foco en atividades estratégicas y ayudando a alcançar ganhos significativos de eficiencia.',
                },
                feature5: {
                    title: 'Procesamiento Inteligente de Documentos',
                    description: 'Construimos soluciones para capturar y almacenar documentos de manera inteligente, añadiendo información y herramientas analíticas que mejoran la manipulación y comprensión de datos. Nuestro enfoque asegura un almacenamiento eficiente y una gestión efectiva tanto de documentos digitalizados como generados automáticamente.',
                },
                feature6: {
                    title: 'Análisis de Datos y BI',
                    description: 'La automatización de procesos, documentos y captura de datos de nuestros clientes genera información valiosa lista para ser explorada, ofreciendo importantes ventajas competitivas. Guiamos a nuestros clientes en este descubrimiento, ayudándoles a desbloquear todo el potencial de sus datos.',
                },
                feature7: {
                    title: 'Integraciones de Sistemas',
                    description: 'Ayudamos a las empresas a integrar sus sistemas internos y externos, creando un anbiente de IT cohesivo que suporta todos los aspectos de las operaciones. Si es necesario conectar sistemas heredados o integrar con aplicaciones externas, proporcionamos soluciones que garantizan la comunicación y el flujo de datos sin interrupciones.',
                    }
            },
            team: {
            title:'Conoce a Nuestro Equipo',
                nunoperdigao: {
                    name: 'Nuno Perdigão',
                    role: 'CEO | Fundador',
                    description: 'Lidera el desarrollo de negocios con más de 21 años de experiencia',
                },
                ricardojorge: {
                    name: 'Ricardo Jorge',
                    role: 'Director | Fundador',
                    description: '22 años en IT, especializado en gestión de proyectos y diseño de soluciones para banca y seguros',
                },
                pedrosilva: {
                    name: 'Pedro Nuno Silva',
                    role: 'Director | Fundador',
                    description: 'Experto en gestión de proyectos, automatización y arquitectura de soluciones con más de 14 años de experiencia',
                },
                brunoanastacio: {
                    name: 'Bruno Anastácio',
                    role: 'Desarrollador de Software Senior',
                    description: 'Desarrollador Full Stack especializado en automatización de procesos e integración',
                },
                joaoverdilheiro: {
                    name: 'João Verdilheiro',
                    role: 'Desarrollador de Software Senior',
                    description: 'Desarrollador Full Stack especializado en automatización de procesos e integración',
                },                  
                flaviogil: {
                    name:"Flávio Gil",
                    role:"Desarrollador de Software Senior",
                    description:"Desarrollador de Software Senior especializado en tecnologías de automatización de IBM"
                },
                bernardorodrigues: {
                    name:"Rui Bernardo Rodrigues",
                    role:"Desarrollador de Software"                    
                },
                antonioeusebio: {
                    name:"António Eusébio",
                    role:"Desarrollador de Software"                    
                },
                ritaandrino: {
                    name:"Rita Andrino",
                    role:"Desarrollador de Software"                    
                }
            },
            contacts: {
                title: 'Contáctanos',
                email: {
                    title: 'Correo electrónico',
                    address: 'geral@dosmart.pt',
                    description: 'Ponte en contacto con nosotros para cualquier consulta o colaboración.'
                },
                phone: {
                    title: 'Teléfono',
                    number: '+351 241 098 183',
                    description: 'Estamos aquí para apoyar tu viaje de transformación digital.'
                },
                address: {
                    title: 'Oficina',
                    description: '¡Conéctate con nosotros hoy!',
                    line1: 'Rua José Dias Simão, s/n,',
                    line2: 'TagusValley, Ed. Inov.Point,',
                    line3: '2200-062 Abrantes'
                },
            },
            support: {
                title: 'Apoyos',
                titleSecondary: 'Estágios Iniciar e Estágios +Talento - IEFP',
                description: 'Promover la inserción y reintegración en el mercado laboral',
                sheet: 'Ficha del proyecto',                
                support2title: 'Medida +Emprego - IEFP', 
            },   
            footer: {
                copyright: '©2026 Do Smart IT Consulting, LDA, una sociedad de responsabilidad limitada portuguesa. Todos los derechos reservados.',
                links: {
                    home: 'Inicio',
                    services: 'Servicios',
                    skills: 'Habilidades y Experiencia',
                    team: 'Equipo',
                    contacts: 'Contactos',
                }
            }          
        }
      },
      fr: {
        translation: {
            home: {
                slogan: 'FRANCES', 
                description: 'Embrace the change with IT Solutions to revolutionize your business',
                mission: 'Our mission is to drive digital transformation for businesses by delivering tailored automation solutions that enhance efficiency, optimize processes, and improve customer experiences.'
            },
            services: {
                title: 'Our Services', 
                description: 'At DoSmart, we offer a range of services designed to help your business thrive in the digital age',
                service1: {
                    title: 'Strategic IT Consulting', 
                    description: 'With extensive experience in business process management and IT consulting, DoSmart helps you challenge your current strategies, structure your initiatives, and adopt the governance models that best fit your unique challenges',
                },
                service2: {
                    title: 'Dedicated IT Support', 
                    description: 'At DoSmart, we understand that implementing new technologies is just the beginning. Our dedicated support team ensures that your solutions continue to run smoothly, providing assistance whenever you need it.',
                },
                service3: {
                    title: 'End-to-End Software Development', 
                    description: 'Our software development services are focused on delivering solutions that meet your specific needs. From initial concept to final implementation, we ensure that every project is completed with the highest level of quality and efficiency',
                },
                service4: {
                    title: 'Comprehensive Training Programs', 
                    description: 'We believe that informed clients are better equipped to succeed. Our training programs are designed to transfer knowledge to your team, ensuring they can manage and expand your initiatives independently',
                },
            },
            features: {
                title: 'Team Skills and Experience', 
                description: 'We bring the expertise and capabilities to streamline operations, enhance decision-making, and drive innovation across your organization, leveraging our experience and skills to deliver impactful solutions.',
                feature1: {
                    title: 'Business Process Management (BPM)', 
                    description: 'We specialize in automating business processes from start to finish, ensuring that human, robotic, and system activities are seamlessly integrated. Our BPM solutions provide a clear roadmap for each process, enabling all stakeholders to understand what needs to be done and when.',
                },
                feature2: {
                    title: 'Business Rules Management (Decisions)', 
                    description: 'We streamline the management of your business rules by centralizing, defining, classifying and automating them. We help creating rules that support workflows, ensuring that critical decisions, such as product scoring or offer optimization, are consistent, efficient and reliable.',
                },
                feature3: {
                    title: 'Artificial Intelligence & Machine Learning', 
                    description: 'By bringing intelligence into your business, we help you predict trends, automate decisions, and improve overall process performance.',
                },
                feature4: {
                    title: 'Robotics Process Automation (RPA)', 
                    description: 'We build RPA solutions to free your employees from time-consuming, repetitive tasks, allowing them to focus on more strategic activities and help you achieve significant efficiency gains.',
                },
                feature5: {
                    title: 'Intelligent Document Processing', 
                    description: 'We build solutions to capture and store documents intelligently, adding insights and analytical tools that enhance data manipulation and understanding. Our approach ensures efficient storage and effective management of both digitized and automatically generated documents.',
                },
                feature6: {
                    title: 'Data Analytics & BI', 
                    description: 'The automation of processes, documents and data capture from our clients generates valuable information ready for exploration, offering significant competitive advantages. We guide our clients on this discovery, helping them unlock the full potential of their data.',
                },
                feature7: {
                    title: 'System Integrations', 
                    description: 'We help businesses integrate their internal and external systems, creating a cohesive IT environment that supports all aspects of operations. Whether you need to connect legacy systems or integrate with external applications, we provide solutions that ensure seamless communication and data flow.',
                }
            },
            team: {
                title:'Meet Our Team',
                nunoperdigao: {
                    name: 'Nuno Perdigão', 
                    role: 'CEO | Founder', 
                    description: 'Leads business development with over 21 years experience',
                },
                ricardojorge: {
                    name: 'Ricardo Jorge', 
                    role: 'Director | Founder', 
                    description: '22 years in IT, specialized in project management and solutions design for banking and insurance',
                },
                pedrosilva: {
                    name: 'Pedro Nuno Silva', 
                    role: 'Director | Founder', 
                    description: 'Expert in project management and solution architecture and automation with 14+ years experience',
                },
                brunoanastacio:{
                    name:"Bruno Anastácio",
                    role:"Senior Software Developer",
                    description:"Full Stack Developer skilled in process automation and integration"
                },
                joaoverdilheiro: {
                    name:"João Verdilheiro",
                    role:"Senior Software Developer",
                    description:"Full Stack Developer skilled in process automation and integration"
                },
                flaviogil: {
                    name:"Flávio Gil",
                    role:"Senior Software Developer",
                    description:"Senior Developer skilled in IBM automation technologies"
                },
                    bernardorodrigues: {
                    name:"Rui Bernardo Rodrigues",
                    role:"Software Developer"                    
                },
                    antonioeusebio: {
                    name:"António Eusébio",
                    role:"Software Developer"                    
                },
                    ritaandrino: {
                    name:"Rita Andrino",
                    role:"Software Developer"                    
                }
            },
            contacts: {
                title: 'Contact Us',
                email: {
                    title: 'Email',
                    address: 'geral@dosmart.pt',
                    description: 'Reach out to us for any inquiries or collaborations.'
                },
                phone: {
                    title: 'Phone',
                    number: '+351 241 098 183',
                    description: 'We are here to support your digital transformation journey.'
                },
                address: {
                    title: 'Office',
                    description: 'Connect with us today!',
                    line1: 'Rua José Dias Simão, s/n,',
                    line2: 'TagusValley, Ed. Inov.Point,',
                    line3: '2200-062 Abrantes'
                },
            },
            footer: {
                copyright: '©2026 Do Smart IT Consulting, LDA, a Portuguese limited liability company. All rights reserved.',
                links: {
                    home: 'Home',
                    services: 'Services',
                    skills: 'Skills & Experience',
                    team: 'Team',
                    contacts: 'Contacts',
                }
            }          
        }
      }
    }
  });

export default i18n;